import React, { useEffect, useRef } from "react";

const GridScan = ({
  lineColor = "#ff3cac",
  bgColor = "#12061f",
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resize();
    window.addEventListener("resize", resize);

    const centerX = () => canvas.width / 2;
    const centerY = () => canvas.height / 2;

    let depthOffset = 0;

    const draw = () => {
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.strokeStyle = lineColor;
      ctx.lineWidth = 1;
      ctx.globalAlpha = 0.6;

      const gridCount = 30;
      const maxDepth = 1200;

      // Perspective horizontal lines
      for (let i = 1; i < gridCount; i++) {
        const z = ((i * 40 + depthOffset) % maxDepth) / maxDepth;
        const scale = 1 - z;

        const y =
          centerY() +
          (i * 30 * scale);

        ctx.beginPath();
        ctx.moveTo(
          centerX() - canvas.width * scale,
          y
        );
        ctx.lineTo(
          centerX() + canvas.width * scale,
          y
        );
        ctx.stroke();
      }

      // Perspective vertical lines
      for (let i = -gridCount; i <= gridCount; i++) {
        ctx.beginPath();
        ctx.moveTo(centerX(), centerY());
        ctx.lineTo(
          centerX() + i * 80,
          canvas.height
        );
        ctx.stroke();
      }

      depthOffset += 6;
      requestAnimationFrame(draw);
    };

    draw();

    return () => window.removeEventListener("resize", resize);
  }, [lineColor, bgColor]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
      }}
    />
  );
};

export default GridScan;
